import React, { useEffect } from 'react'
import { Accordion, List } from 'antd-mobile'
import { getFeedbackType } from '@feedback/services/index'
import { useRequest } from 'ahooks'
import { getTextByKey } from '@feedback/utils/util'
import './App.scss'
interface Props {
  history: any
}
//问题分类页面
const App: React.FC<Props> = ({ history }) => {
  const { data: feedbackType = {} } = useRequest(() => getFeedbackType())
  const toDetail = (type_id: string, type_str: string) => {
    history.push(`/v1/ticketForm?feedback_type=${type_id}&feedback_type_str=${type_str}`)
  }
  useEffect(() => {
    document.title = 'problem type'
  }, [])
  // 递归处理
  const renderList = (objList: any) => {
    if (!Array.isArray(objList)) {
      return null
    }
    return (
      <Accordion>
        {objList.map((item: any) => (
          <Accordion.Panel
            header={
              item.children ? (
                item.name
              ) : (
                <div
                  style={{ width: '100%' }}
                  onClick={() => {
                    toDetail(item.id, item.name)
                  }}
                >
                  {`${item.parent_id > 0 ? '     ' : ''}${item.name}`}
                </div>
              )
            }
            className={`${item.children ? '' : 'last-child'}`}
            key={item._id}
          >
            {Array.isArray(item.children) && renderList(item.children)}
          </Accordion.Panel>
        ))}
      </Accordion>
    )
  }
  return (
    <div className='p-question-type'>
      <p className='label'>{getTextByKey('tip question2')}</p>
      <div className='c-question-panel'>{Array.isArray(feedbackType.data) && renderList(feedbackType.data)}</div>
    </div>
  )
}

export default App
